import React, { Component } from 'react'
import { connect } from 'react-redux'
import { storage } from '../../../../config/firebaseConfig';
import { createFloor } from '../../../../store/actions/floorActions';
import Loader from 'react-loader-spinner';
import * as MDICONS from '@material-ui/icons';
import FutureMap from '../../../widgets/FutureMap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { uploadMoreFilesInProject } from '../../../../store/actions/projectActions';

class AddFilesModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedFiles: [],
            selectedFilesNames: [],
        }
    }

    /// README: UTILS
    toLowercaseWithoutSpaces = (val) => {
        return val.replaceAll(/[/\-.\s]/g, '').toLowerCase();
    }

    removePdfExt = (val) => {
        const extLength = 'pdf'.length;
        return val.substring(0, val.length - extLength);
    }

    /// README: UPLOAD NEW FILES TO PROJECT
    handleSubmit = (e) => {
        e.preventDefault();
        const { proid } = this.props.snagDetail;
        const { selectedFiles } = this.state;

        if (selectedFiles.length > 0) {
            this.props.uploadMoreFilesInProject(proid, selectedFiles);
        } else {
            alert("Please attach at least 1 pdf file");
        }
    }


    /// README: FILE ATTACHMENT FUNCTIONS
    onChangeHandler = (e) => {
        const { selectedFiles, selectedFilesNames } = this.state;
        var newSelectedFiles = selectedFiles;
        var newSelectedFilenames = selectedFilesNames;

        if (this.maxSelectFile(e) && this.checkMimeType(e) && this.checkFileSize(e)) {
            var filteredFiles = this.removeRedundantFilenames(e.target.files);
            var filteredFilenames = this.getFilenames(filteredFiles)

            newSelectedFiles = [...newSelectedFiles, ...filteredFiles];
            newSelectedFilenames = [...newSelectedFilenames, ...filteredFilenames];

            this.setState(() => ({
                selectedFiles: newSelectedFiles,
                selectedFilesNames: newSelectedFilenames,
            }));
        }
    }

    getFilenames = (files) => {
        var filenames = [];
        files.forEach((file) => filenames.push(this.processFilenames(file.name)));
        return filenames;
    }

    removeRedundantFilenames = (files) => {
        const { imageFilesList } = this.props.snagDetail;
        const { selectedFiles } = this.state;

        // check if files are already not in state
        var filteredFiles = [...files].filter(s => selectedFiles.every(t => {
            return s.name !== t.name
        }));

        // check if filteredFiles not already in imageFilesList
        filteredFiles = filteredFiles.filter(s => imageFilesList.every(t => {
            return this.processFilenames(s.name) !== t
        }));

        return filteredFiles;
    }

    processFilenames = (filename) => {
        return this.removePdfExt(this.toLowercaseWithoutSpaces(filename));
    }

    maxSelectFile = (e) => {
        let files = e.target.files
        if (files.length > 100) {
            const msg = 'Only 100 pdf files can be uploaded at a time'
            alert(msg);
            e.target.value = null

            return false;
        }
        return true;
    }

    checkFileSize = (e) => {
        let files = e.target.files
        let size = 5242880;
        let err = "";
        for (var x = 0; x < files.length; x++) {
            if (files[x].size > size) {
                err = 'File is too large, please pick a smaller file\n';
                alert(err);
            }
        };
        if (err !== '') {
            e.target.value = null
            toast.error(err)
            return false
        }
        return true;
    }

    checkMimeType = (e) => {
        let files = e.target.files
        let err = ''
        const types = ['application/pdf']
        for (var x = 0; x < files.length; x++) {
            if (!types.includes(files[x].type)) {
                err = 'File is not in a supported format\n';
                alert(err);
            }
        };
        if (err !== '') {
            e.target.value = null // discard selected file
            toast.error(err)
            return false;
        }
        return true;
    }

    /// README: RENDER THE UI
    render() {
        const { selectedFiles, selectedFilesNames } = this.state;
        const { modalTitleStyle, formLabelStyle, modalWidth, snagDetail, appControl } = this.props;
        const { modalInfoTextStyle } = appControl;
        const { proid, imageFilesList } = snagDetail;

        //////////////////////////////////////////////////////////////////////////////////////////////
        /// README: seeing the state of form (do styling adjustments but be cautious with state)
        ///
        const { isMoreFilesAdding, isMoreFilesAdded } = this.props.project;
        const textStyle = {
            color: this.props.themeColors.darkThemeColor,
        }
        const relevantSubmitComponent = isMoreFilesAdding ?
            (<React.Fragment>
                <Loader
                    type="TailSpin"
                    color={this.props.themeColors.themeColor}
                    height={20}
                    width={20}
                />
                <br></br>
                <p style={textStyle}>{isMoreFilesAdded ? "Syncing files with database..." : "Uploading files..."}</p>
                <br></br>
            </React.Fragment>)
            :
            (<button className="btn btn-sm btn-dark" onClick={this.handleSubmit}>Upload new files</button>);

        //////////////////////////////////////////////////////////////////////////////////////////////
        /// README: return the form
        ///
        return (
            <div className="dynamicModalContainer">
                <div className="dynamicModalSm">
                    <br></br>
                    {[...imageFilesList].length > 0 ? <React.Fragment>
                        {/* Display all uploaded files */}
                        <div style={{ height: "160px", overflow: "hidden", overflowY: "auto" }}>
                            <h5 style={modalTitleStyle}>All files in this project</h5>
                            <p style={modalInfoTextStyle}>Tap on any file for a preview</p>
                            <ul className="list-group align-items-start list-group-flush">
                                {imageFilesList.map((fileName, i) => (
                                    <li style={{ fontSize: "13px" }} className="list-group-item py-1 border-0" ng-repeat="i in filters" key={i}>
                                        <b>{i + 1}. </b><FutureMap isCirclePreview={false} floorMap={{ fileName, proid }} styleClass="avatar" height="150px" />
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <hr></hr>
                    </React.Fragment> : <React.Fragment />
                    }
                    {/* Files attach button */}
                    <div className="d-flex justify-content-between">
                        <div className="d-flex flex-row">
                            <div className="align-self-center" >
                                <h5 style={modalTitleStyle}>Attach new files</h5>
                                <p style={modalInfoTextStyle}>{ [...imageFilesList].length > 0 ? 'Note: Any duplicate file either attached multiple times or already uploaded will be ignored' : 'Note: Any duplicate file attached multiple times will be ignored'}</p>
                            </div>
                        </div>
                        <div className="d-flex flex-row">
                            <div className="align-self-center">
                                <label htmlFor="files">
                                    <span role="button" className="btn btn-light btn-sm" >
                                        <MDICONS.Add />
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div style={{ height: "120px", overflow: "hidden", overflowY: "auto" }}>
                        <ul className="list-group align-items-start list-group-flush">
                            {selectedFiles.map((fileName, i) => (
                                <li style={{ fontSize: "13px" }} className="list-group-item py-2 border-0" ng-repeat="i in filters" key={i}>
                                    <b>{i + 1}. </b>{`${fileName.name}`}
                                    <br></br>
                                    <span style={{ fontSize: "10px", color: "GrayText", fontStyle: "italic" }}>(Formatted as: {selectedFilesNames[i]})</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="form-group text-left">
                        <input type="file" className="file" id="files" multiple onChange={this.onChangeHandler} style={{ fontWeight: "bold", fontSize: "8px", display: "none" }} />
                    </div>
                    <br></br>
                    {/* File upload button */}
                    {relevantSubmitComponent}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        alu: state.alu,
        formLabelStyle: state.appControl.formLabelStyle,
        project: state.project,
        modalWidth: state.appControl.modalWidth,
        modalTitleStyle: state.appControl.modalTitleStyle,
        appControl: state.appControl,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        uploadMoreFilesInProject: (proid, selectedFiles) => dispatch(uploadMoreFilesInProject(proid, selectedFiles))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddFilesModal)
